export default __webpack_public_path__ + "static/media/capitalFinanceIslamic.701aa229.webm";